import { Link } from "react-router-dom";

const COLUMNS: { title: string; links: { label: string; to: string }[] }[] = [
  {
    title: "栏目频道",
    links: [
      { label: "综艺名场面", to: "/category/zongyi" },
      { label: "影视热映", to: "/category/yingshi" },
      { label: "乐坛现场", to: "/category/yinyue" },
      { label: "圈内观察", to: "/category/guancha" },
    ],
  },
  {
    title: "热门合集",
    links: [
      { label: "综艺名场面盘点", to: "/category/zongyi" },
      { label: "暑期影视观察", to: "/detail/qixiaying-dianshi-chaoxi" },
      { label: "舞台实力派回归", to: "/detail/yinyuewutai-shengyin" },
      { label: "慢综艺治愈经济学", to: "/detail/weilaizongyi-ai-pingjia" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容与原则", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "返回首页", to: "/" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-secondary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg leading-none" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                海角<span className="text-primary-600">吃瓜</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              按热度聚合圈内新鲜瓜料与高赞讨论，综艺、影视、乐坛、行业观察一网打尽，帮你轻松追上每一次讨论进度。
            </p>
            <a
              href="mailto:hello@haijiao.example"
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-primary-600"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              hello@haijiao.example
            </a>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="font-heading text-base font-bold text-foreground-900">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm whitespace-nowrap text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-8 lg:px-12">
          <p>© 2026 海角吃瓜 · 娱乐内容聚合站。本站内容仅供信息浏览与讨论参考。</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            吃瓜有度 · 理性追更
            <i className="ri-heart-3-line text-primary-500" aria-hidden="true"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}